export default function() {

  // Functions
  // -------------------
  
  function initList() {
    let categorySelect = document.getElementById('catSelect')
    let items = document.querySelectorAll('.item-wrap')
    // let products = document.querySelectorAll('.product-wrap')
  
    if (categorySelect != null) {
  
      categorySelect.addEventListener('change', (e) => {
        let category = e.path[0].value
        filterList(category, items)
      })
    
    }
  }
  
  function filterList(category, items) {
    let hideCounter = 0
    let showCounter = 0
  
    let itemsList = document.querySelector('.items-list')
    let itemsListWrap = document.querySelector('.items-list-wrap')
  
    // ChangeItems List Wrap Height
    setTimeout(() => {
      if (hideCounter < showCounter) {
        // console.log(hideCounter + " vs " + showCounter)
        // console.log(itemsList.clientHeight)
        itemsListWrap.style.height = itemsList.clientHeight + "px"
      }
    }, 200)
    
    setTimeout(() => {
      if (hideCounter > showCounter) {
        // console.log(hideCounter + " vs " + showCounter)
        // console.log(itemsList.clientHeight)
        itemsListWrap.style.height = itemsList.clientHeight + "px"
      }
    }, 1200)
  
    
    // Make sure 'category' is not empty
    if(category.length > 0) {
  
      // Loop Through Items
  
      items.forEach((item) => {
  
        if(![...item.classList].includes(category)) {
  
          setTimeout(() => {
            item.classList.add('fade')
          }, hideCounter)
          
          setTimeout(() => {
            item.classList.add('hide')
          }, 400 + hideCounter)
          
          hideCounter += 100
          
        } else {
          item.classList.remove('hide')
          
          setTimeout(() => {
            item.classList.remove('fade')
          }, 400 + showCounter)
  
          showCounter += 100
        }
        
      })
  
    } else {
  
      items.forEach((item) => {
  
        if([...item.classList].includes('hide')) {
          item.classList.remove('hide')
  
          setTimeout(() => {
            item.classList.remove('fade')
          }, 400 + showCounter)
  
          showCounter += 100
        }
  
      })
  
    }
  
    // Display Message if empty
    items.forEach((item) => {
      setTimeout(() => {
        if([...item.classList].includes('empty')) {
          if(showCounter == 0) {
  
            item.classList.remove('hide')
            
            setTimeout(() => {
              item.classList.remove('fade')
            }, 400)
              
          } else {
            setTimeout(() => {
              item.classList.add('fade')
            }, hideCounter)
            
            setTimeout(() => {
              item.classList.add('hide')
            }, 400 + hideCounter)
          }
        }
      }, 400 + hideCounter)
    })
  
  }
  
  // Events
  // -------------------
  document.addEventListener('DOMContentLoaded', function() {
    initList()
  })
  
  // Correct for swup
  document.addEventListener('swup:contentReplaced', function() {
    initList()
  })
}